import { useEffect, useState } from "react";
import Dropdownitem from "./Dropdownitem/Dropdownitem";
import "./InputDropdown.scss";

const InputDropdown = ({
  dropdowndata,
  searchText,
  handleDropDownClose,
  inputcontent,
  notSearchable,
  detectBlur,
  setBlur,
  InputConfig,
  value,
}) => {
  const [selectedOption, setSelectedOption] = useState(-1);
  const [data, setData] = useState(dropdowndata);
  const [count, setCount] = useState(0);
  console.log(notSearchable, dropdowndata, data, "open2");
  useEffect(() => {
    if (!searchText || searchText?.length === 0 || notSearchable || InputConfig?.notSearchable) {
      setData(dropdowndata);
    } else {
      let filteredData = dropdowndata?.filter((el, i) => {
        let searchValue = isNaN(searchText) ? searchText.toLowerCase() : searchText;
        let element = el;
        element = isNaN(el) ? el?.toLowerCase() : el;
        if (element?.includes(searchValue)) {
          return el;
        }
      });

      setData(filteredData);
    }
  }, [searchText]);

  useEffect(() => {
    if (searchText && detectBlur && !dropdowndata?.includes(searchText)) {
      if (data?.length > 0) {
        inputcontent(createEvent(data[0]));
      } else {
        inputcontent(createEvent(""));
      }
      setBlur(false);
    }
  }, [detectBlur, searchText]);

  useEffect(() => {
    function handleKeyDown(event) {
      if ((event.keyCode === 9 && count === 0) || (event.keyCode !== 38 && event.keyCode !== 40)) {
        setCount(1);
        setSelectedOption(0);

        if (searchText && !dropdowndata?.includes(searchText) && event.keyCode === 9) {
          if (data.length > 0) {
            inputcontent(createEvent(data[0]));
          } else {
            inputcontent(createEvent(""));
          }
        }
        // handleDropDownClose();
        // inputcontent();
        return;
      }
      event.preventDefault();

      if (event.keyCode === 38) {
        if (selectedOption >= 0) {
          // inputcontent(data[selectedOption - 1]);
          // setSelectedOption((prevOption) => prevOption - 1);
          setSelectedOption((prevOption) => {
            const newOption = Math.max(prevOption - 1, 0);

            inputcontent(createEvent(data[newOption]));
            return newOption;
          });
          event.preventDefault();
        } else {
        }
      } else if (event.keyCode === 40) {
        if (data.length !== selectedOption) {
          // inputcontent(data[selectedOption + 1]);
          // setSelectedOption((prevOption) => prevOption + 1);
          setSelectedOption((prevOption) => {
            const newOption = Math.min(prevOption + 1, data.length - 1);

            inputcontent(createEvent(data[newOption]));
            return newOption;
          });
          event.preventDefault();
        } else {
          setSelectedOption(0);

          inputcontent(createEvent(data[0]));
          event.preventDefault();
        }
      }
    }

    async function handleKeyUp(event) {
      if (event.keyCode === 13) {
        inputcontent(createEvent(data[selectedOption]));
        handleDropDownClose();
        setSelectedOption(0);
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    // document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      // document.removeEventListener("keyup", handleKeyUp);
    };
  }, [selectedOption, data]);

  const createEvent = (val) => {
    const event = {
      target: {
        name: InputConfig?.name, // Ensure this uses the correct "name" of the input
        value: val,
      },
    };
    return event;
  };
  return (
    <div className={`Inputdropdown`}>
      {data?.map((e, i) => {
        return (
          <div
            key={i}
            className={i === selectedOption || value === e ? `selectDropdown forHover` : "selectDropdown"}
            onClick={() => {
              inputcontent(createEvent(e));
              // handleDropDownClose();
            }}
          >
            <Dropdownitem text={e} />
          </div>
        );
      })}
    </div>
  );
};

export default InputDropdown;
